import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12e8ae68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job-and-task" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Job and Task Template", -1))
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "table-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Job Templates", -1))
const _hoisted_6 = {
  key: 0,
  class: "styled-table"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sr. No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Part ref."),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_8 = ["onMouseover"]
const _hoisted_9 = {
  key: 0,
  class: "popover"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_13 = { class: "table-wrapper" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Templates", -1))
const _hoisted_15 = {
  key: 0,
  class: "styled-table"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sr. No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Work Center"),
    /*#__PURE__*/_createElementVNode("th", null, "Cost Center"),
    /*#__PURE__*/_createElementVNode("th", null, "JT Name"),
    /*#__PURE__*/_createElementVNode("th", null, "JT Order"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_17 = ["onMouseover"]
const _hoisted_18 = {
  key: 0,
  class: "popover"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "loading-container"
}

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { fetchAllTaskTemplates, fetchAllJobTemplates, deleteFromUrl } from '@/api/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobAndTaskTemplate',
  setup(__props) {

const taskTemplates = ref([]);
const jobTemplates = ref([]);
const isLoadingTasks = ref(true);
const isLoadingJobs = ref(true);
const showDescription = ref(null);
const router = useRouter();

onMounted(async () => {
  await fetchTemplates();
});

const fetchTemplates = async () => {
  taskTemplates.value = await fetchAllTaskTemplates();
  jobTemplates.value = await fetchAllJobTemplates();
  isLoadingTasks.value = false;
  isLoadingJobs.value = false;
};

const truncateDescription = (description) => {
  const maxLength = 50;
  if (description.length > maxLength) {
    return description.substring(0, maxLength) + '...';
  }
  return description;
}

const addTask = () => {
  router.push("/ops/create-task-template");
};

const deleteTask = async (taskId) => {
  if (confirm("Are you sure you want to delete this task?")) {
    try {
      await deleteFromUrl(`/ops/api/tasktemplates/${taskId}/`);
      alert("Task deleted successfully.");
      await fetchTemplates();
    } catch (error) {
      alert("Failed to delete task.");
      console.error("Error deleting task:", error);
    }
  }
};

const addJob = () => {
  router.push("/ops/create-job-template");
};

const deleteJob = async (jobId) => {
  if (confirm("Are you sure you want to delete this job?")) {
    try {
      await deleteFromUrl(`/ops/api/jobtemplates/${jobId}/`);
      alert("Job deleted successfully.");
      await fetchTemplates();
    } catch (error) {
      alert("Failed to delete job.");
      console.error("Error deleting job:", error);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", { class: "title-with-action" }, [
          _hoisted_5,
          _createElementVNode("button", {
            class: "action-button add",
            onClick: addJob
          }, "➕ Add Job Template")
        ]),
        (!isLoadingJobs.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobTemplates.value, (job, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: job.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(job?.name), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "description",
                        onMouseover: ($event: any) => (showDescription.value = job.id),
                        onMouseout: _cache[0] || (_cache[0] = ($event: any) => (showDescription.value = null))
                      }, [
                        _createTextVNode(_toDisplayString(truncateDescription(job?.description)) + " ", 1),
                        (showDescription.value === job.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createTextVNode("Job Description:"),
                              _hoisted_10,
                              _createTextVNode(_toDisplayString(job?.description), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_8)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(job?.part_reference), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "action-button delete",
                        onClick: ($event: any) => (deleteJob(job.id))
                      }, "Delete", 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", { class: "title-with-action" }, [
          _hoisted_14,
          _createElementVNode("button", {
            class: "action-button add",
            onClick: addTask
          }, "➕ Add Task Template")
        ]),
        (!isLoadingTasks.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskTemplates.value, (task, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: task.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(task?.name), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "description",
                        onMouseover: ($event: any) => (showDescription.value = task.id),
                        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (showDescription.value = null))
                      }, [
                        _createTextVNode(_toDisplayString(truncateDescription(task?.description)) + " ", 1),
                        (showDescription.value === task.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createTextVNode("Template Description:"),
                              _hoisted_19,
                              _createTextVNode(_toDisplayString(task?.description), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_17)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(task.work_center ? task.work_center.name : 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(task.cost_center ? task.cost_center.name : 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(task?.job_template_name), 1),
                    _createElementVNode("td", null, _toDisplayString(task?.job_template_order), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "action-button delete",
                        onClick: ($event: any) => (deleteTask(task.id))
                      }, "Delete", 8, _hoisted_20)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21))
      ])
    ])
  ]))
}
}

})